import { LineChart, LineChartProps } from '../../../renderers/line-chart/line-chart.component';
import { IOTS_UPTIME_LINE_CHART_DEFINITION } from './iots-uptime-line-chart.definition';
import { IOTS_UPTIME_LINE_CHART_MOCK_DATA } from './iots-uptime-line-chart.mock';

export const IotsUptimeLineChart = (props: LineChartProps) => (
    <LineChart
        {...props}
        showArea
    />
);

IotsUptimeLineChart.definition = IOTS_UPTIME_LINE_CHART_DEFINITION;
IotsUptimeLineChart.mockData = IOTS_UPTIME_LINE_CHART_MOCK_DATA;
